import React from "react";

const Api_Docs = () => {
  return (
    <div class="page-body-wrapper text-start">
      <div class="row">
        <div class="col-12 col-md-7 col-xl-6">
          <div class="header-title">
            <h1>API Documentation</h1>
            <p>Information about Lightning Proxies Public API</p>
          </div>
        </div>
        <div class="col-12 col-md-5 col-xl-6">
          <div class="header-bttn">
            <p>
              Need Support?{" "}
              <a href="https://t.me/lightningproxies">
                Contact Us <i class="fa fa-angle-right"></i>
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="api-doc-box mt-15">
            <h5>Variables</h5>
            <div class="main-box">
              <table>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                  <th>Type</th>
                </tr>
                <tr>
                  <td>base_url</td>
                  <td>
                    <a href="https://lightningproxies.net/api">
                      https://lightningproxies.net/api
                    </a>
                  </td>
                  <td>string</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="api-doc-box top-border">
            <h5>Authentication</h5>
            <div class="main-box">
              <table>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                  <th>Add to</th>
                </tr>
                <tr>
                  <td>x-api-key</td>
                  <td>
                    <a href="#">Your API Key</a>
                  </td>
                  <td>Header</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="sectional-heading top-border">
            <h5>Sectional Heading</h5>
            <h6>1. Sub Heading A :</h6>
            <p>Endpoint</p>
            <div class="method-box">
              <code className="d-dark">
                Method: <span style={{ color: "#1675FF" }}>ABC </span>
                <br />
                Type: <span style={{ color: "#3ABF7C" }}>DEF</span> <br />
                URL:{" "}
                <span style={{ color: "#FFCB3D" }}>
                  base_url/public-api/123{" "}
                </span>
                <br />
              </code>
              <code className="d-light text-dark">
                Method: <span style={{ color: "#1675FF" }}>ABC </span> <br />
                Type: <span style={{ color: "#3ABF7C" }}>DEF</span> <br />
                URL:{" "}
                <span style={{ color: "#FFCB3D" }}>
                  base_url/public-api/123{" "}
                </span>
                <br />
              </code>
            </div>
            <p>Body</p>
            <div class="api-doc-box">
              <div class="main-box mt-0">
                <table>
                  <tr>
                    <th>Value Field 1</th>
                    <th>Value Field 2</th>
                  </tr>
                  <tr>
                    <td>List Item 01</td>
                    <td>123-456-789-0ab</td>
                  </tr>
                  <tr>
                    <td>List Item 01</td>
                    <td>123-456-789-0ab</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Api_Docs;
